module.exports = __webpack_public_path__ + "img/KSC06667.bba0515b.jpg";